export const DEFAULT_LOCALE = 'en-US';

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = 'pages.homepage';
export const NAV_MESSAGE_BUNDLE_NAME = 'pages.nav';
export const NOT_FOUND_MESSAGE_BUNDLE_NAME = 'pages.notfound';
export const OPT_IN_MESSAGE_BUNDLE_NAME = 'pages.optin';
export const UNSUBSCRIBE_MESSAGE_BUNDLE_NAME = 'pages.unsubscribe';

export const AWS_SKILL_BUILDER_LINK =
  'https://skillbuilder.aws/?tk=ced64b47-4bea-46e1-ba6d-d1740f5b5a22&sc_channel=el';
export const AWS_SKILLS_CENTER_LINK =
  'https://aws.amazon.com/training/skills-centers/?trk=a88368a1-3e46-41dd-9a68-e094e6e77ca9&sc_channel=el';
export const AWS_RESTART_LINK =
  'https://aws.amazon.com/training/restart/?trk=8cfa5f3e-cac2-491a-a419-83645bc4fde2&sc_channel=el';
export const AWS_EDUCATE_LINK = 'https://aws.amazon.com/education/awseducate/';
export const HIRING_OUR_HEROES_LINK = 'https://www.hiringourheroes.org/';
export const DIRECTORS_ELEVATION_LINK = 'https://cherokee.film/directors/';
export const AMAZON_RESEARCH_AWARDS_LINK =
  'https://www.amazon.science/research-awards';
export const DELIVERY_SERVICE_PARTNER_LINK = 'https://logistics.amazon.com/';
export const AMAZON_PRIME_LINK =
  'https://www.aboutamazon.com/news/retail/amazon-prime-access-discounted-membership';
export const AMAZON_PHARMACY_LINK = 'https://pharmacy.amazon.com/';
export const ONE_MEDICAL_LINK = 'https://www.onemedical.com/';
export const AMAZON_ACCESSIBLE_SERVICES_LINK =
  'https://www.amazon.com/b?ie=UTF8&node=15701038011';
export const RISE_HOME_CONSTRUCTION_LINK =
  'https://www.garysinisefoundation.org/programs/custom-homebuilding';
export const SUPPLIER_CONNECT_LINK = 'https://supplierconnect.amazon.com/';
export const AWS_EDUCATION_EQUITY_LINK =
  'https://aws.amazon.com/about-aws/our-impact/education-equity-initiative/';
export const SNOWBALL_EXPRESS_LINK =
  'https://www.garysinisefoundation.org/programs/honoring-families-of-fallen-heroes';
export const AMAZON_LITERARY_LINK =
  'https://www.aboutamazon.com/news/books-and-authors/apply-now-for-this-years-amazon-literary-partnership-grants';
export const AMAZON_VOLUNTEERING_LINK =
  'https://www.aboutamazon.com/news/community/amazon-global-volunteering';
export const CAREERS_LINK = 'https://share.google/lGLyTyS4nfqzYwAVB';
export const CONDITIONS_OF_USE_LINK =
  'https://www.amazon.com/gp/help/customer/display.html?nodeId=508088';
export const PRIVACY_NOTICE_LINK =
  'https://www.amazon.com/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ&ref_=footer_privacy';
